/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierVisitStatus } from '../model';
// @ts-ignore
import type { CreateTruckAppointmentCommand } from '../model';
// @ts-ignore
import type { GetTruckAppointmentsQueryType } from '../model';
// @ts-ignore
import type { TruckAppointmentDto } from '../model';
// @ts-ignore
import type { TruckAppointmentDtoPaginatedList } from '../model';
// @ts-ignore
import type { UpdateTruckAppointmentCommand } from '../model';
/**
 * TruckAppointmentsApi - axios parameter creator
 */
export const TruckAppointmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {GetTruckAppointmentsQueryType} [type] 
         * @param {CarrierVisitStatus} [status] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (page: number, pageSize: number, type?: GetTruckAppointmentsQueryType, status?: CarrierVisitStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('get', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('get', 'pageSize', pageSize)
            const localVarPath = `/planning/api/TruckAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['Type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['Status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateTruckAppointmentCommand} [createTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post: async (createTruckAppointmentCommand?: CreateTruckAppointmentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/TruckAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTruckAppointmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTruckAppointmentCommand} [updateTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (updateTruckAppointmentCommand?: UpdateTruckAppointmentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/TruckAppointments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTruckAppointmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id)
            const localVarPath = `/planning/api/TruckAppointments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TruckAppointmentsApi - functional programming interface
 */
export const TruckAppointmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TruckAppointmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {GetTruckAppointmentsQueryType} [type] 
         * @param {CarrierVisitStatus} [status] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(page: number, pageSize: number, type?: GetTruckAppointmentsQueryType, status?: CarrierVisitStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckAppointmentDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(page, pageSize, type, status, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckAppointmentsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateTruckAppointmentCommand} [createTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async post(createTruckAppointmentCommand?: CreateTruckAppointmentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.post(createTruckAppointmentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckAppointmentsApi.post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateTruckAppointmentCommand} [updateTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(updateTruckAppointmentCommand?: UpdateTruckAppointmentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TruckAppointmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(updateTruckAppointmentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckAppointmentsApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TruckAppointmentsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TruckAppointmentsApi - factory interface
 */
export const TruckAppointmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TruckAppointmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {GetTruckAppointmentsQueryType} [type] 
         * @param {CarrierVisitStatus} [status] 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(page: number, pageSize: number, type?: GetTruckAppointmentsQueryType, status?: CarrierVisitStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<TruckAppointmentDtoPaginatedList> {
            return localVarFp.get(page, pageSize, type, status, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateTruckAppointmentCommand} [createTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(createTruckAppointmentCommand?: CreateTruckAppointmentCommand, options?: RawAxiosRequestConfig): AxiosPromise<TruckAppointmentDto> {
            return localVarFp.post(createTruckAppointmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateTruckAppointmentCommand} [updateTruckAppointmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(updateTruckAppointmentCommand?: UpdateTruckAppointmentCommand, options?: RawAxiosRequestConfig): AxiosPromise<TruckAppointmentDto> {
            return localVarFp.put(updateTruckAppointmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TruckAppointmentsApi - object-oriented interface
 */
export class TruckAppointmentsApi extends BaseAPI {
    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {GetTruckAppointmentsQueryType} [type] 
     * @param {CarrierVisitStatus} [status] 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(page: number, pageSize: number, type?: GetTruckAppointmentsQueryType, status?: CarrierVisitStatus, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return TruckAppointmentsApiFp(this.configuration).get(page, pageSize, type, status, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateTruckAppointmentCommand} [createTruckAppointmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public post(createTruckAppointmentCommand?: CreateTruckAppointmentCommand, options?: RawAxiosRequestConfig) {
        return TruckAppointmentsApiFp(this.configuration).post(createTruckAppointmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateTruckAppointmentCommand} [updateTruckAppointmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public put(updateTruckAppointmentCommand?: UpdateTruckAppointmentCommand, options?: RawAxiosRequestConfig) {
        return TruckAppointmentsApiFp(this.configuration).put(updateTruckAppointmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public remove(id: number, options?: RawAxiosRequestConfig) {
        return TruckAppointmentsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
}

